<template>
    <div class="privacy-policy">
        <div v-wechat-title="privacyPolicy.title"></div>
        <div class="privacy-main" v-html="privacyPolicy.content"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            privacyPolicy: {},
            requestUrl: ""
        };
    },
    created() {
        let params = this.$route.query;
        const { source } = params;
        //source=1  注册服务协议   source=0  隐私政策
        if (source != 1) {
            this.requestUrl = "h5/notice/getPrivacyPolicy";
        } else {
            this.requestUrl = "h5/notice/getRegisterPolicy";
        }
        this.getData(this.requestUrl); //详细内容
    },
    methods: {
        getData: function(url) {
            this.$request({
                method: "get",
                /* url: "/h5/notice/getPrivacyPolicy" */
                url: url
            })
                .then(res => {
                    const { code, msg, data } = res;
                    this.privacyPolicy = data;
                })
                .catch(err => {
                    this.$toast(err);
                });
        }
    }
};
</script>

<style lang="less" scoped>
.privacy-policy {
    width: 100%;
    background: #fff;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 20px 16px;
    margin-bottom: 10px;
    .privacy-main {
        font-size: 13px;
        color: #333333;
        line-height: 20px;
    }
    .privacy-title {
        text-align: center;
        display: block;
        width: 100%;
        font-size: 15px;
        color: #333333;
        margin-bottom: 18px;
        line-height: 20px;
    }
    p {
        display: block;
        font-size: 12px;
        color: #333333;
        text-align: justify;
        line-height: 22px;
        font-weight: 300;
    }
}
</style>
